export default __webpack_public_path__ + "static/media/verifiEmail.1d1fd3b6.png";